import { State, Selector, Action } from '@ngxs/store';
import { Injectable } from '@angular/core';

const defaultState = {
  codePage: null,
  codeSection: null
};

export interface NavigationStateModel {
  codePage: string;
  codeSection: string;
}

export class SetCurrentCodePage {
  static type = '[Navigation] SetCurrentCodePage';
  constructor(public codePage: string) {}
}

export class SetCurrentCodeSection {
  static type = '[Navigation] SetCurrentCodeSection';
  constructor(public codeSection: string) {}
}

@Injectable()
@State<NavigationStateModel>({
  name: 'navigation',
  defaults: defaultState
})
export class NavigationState {
  @Selector()
  static navigation(state: NavigationStateModel) {
    return state;
  }

  @Action(SetCurrentCodePage)
  setCurrentCodePage({ patchState }, { codePage }: SetCurrentCodePage) {
    patchState({
      codePage: codePage
    });
  }

  @Action(SetCurrentCodeSection)
  setCurrentCodeSection({ patchState }, { codeSection }: SetCurrentCodeSection) {
    patchState({
      codeSection: codeSection
    });
  }
}
